/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
 */
export interface MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof MergedCardTransactionDetailMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


